import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/log.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "红8直播APP"),
    /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "一起让看球变得更加简单")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"left\"><img class=\"logo\" src=\"" + _imports_0 + "\" alt=\"\"><div class=\"text\"><div class=\"title\">红8直播APP</div><div class=\"subtitle\">高清观看世界杯·卡塔尔合作伙伴</div></div></div>", 1)

import Home from "../components/Home.vue";
import MatchIndex from "../components/MatchIndexss.vue";

import New from "../components/Newsletter.vue";
import Circle from "../components/Circle.vue";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  name: 'Home',
  setup(__props) {

const active = ref(0);

const toupdatePage = () => {
  window.open("https://update.h8tv.tv");
};
const toh5page = () => {
  window.open("https://m.h8tv.tv");
};

// APP下载
const download = () => {
  let wins = "";
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    wins = "Android";
  } else {
    wins = "ios";
  }
  if (wins == "ios") {
    down();
  } else {
    window.location.href =
      "https://h8tv.oss-accelerate.aliyuncs.com/app/h8zb.apk"; //安卓下载
  }
};
const down = () => {
  location.href =
    "https://h8tv.oss-accelerate.aliyuncs.com/app/h8zb.mobileconfig";
  var i = 0;
  var t1 = setInterval(function () {
    iosConfig();
  }, 3000);
  function iosConfig() {
    if (i > 0) {
      clearInterval(t1);
    }
    i++;
    location.href =
      "https://h8tv.oss-accelerate.aliyuncs.com/app/setup.mobileprovision";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_sticky = _resolveComponent("van-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_sticky, { "offset-top": 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", { class: "topBox" }, [
          _hoisted_1,
          _createElementVNode("div", {
            class: "down",
            onClick: toh5page
          }, "官方高清直播")
        ])
      ]),
      _: 1
    }),
    _createVNode(MatchIndex, { onUpdara: download }),
    _createElementVNode("div", { class: "footer" }, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "down",
        onClick: download
      }, "APP下载")
    ])
  ], 64))
}
}

})